import React from "react";
import Table from "../../Common/Table";
import useDashboardTable from "./useDashboardTable";
import { Link } from "react-router-dom";
import icons from "../../../assets/images/constantIcons";
import RunningBooking from "./RunningBooking";
import UpcommingsBooking from "./UpcommingsBooking";

const DashboardTable = () => {
  const { columns, data } = useDashboardTable();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3  gap-5 my-3 px-0 md:px-5">
      <div>
        <div className="flex justify-between items-center">
          <h1 className="text-heading text-lg xl:text-xl font-semibold mb-3 lg:mb-2">
            Table
          </h1>
          <Link to="/mainDashboard/table">
            <button className="cta !text-green font-bold rounded-full flex items-center mb-4">
             <p className="text-xs">View All</p> 
              <icons.FaArrowRightLong className="ml-2" />
            </button>
          </Link>
        </div>
        <div className="overflow-auto horizontalscroll h-[400px] vertical">
          <Table columns={columns} data={data} />
        </div>
      </div>
      <div className="">
        <RunningBooking />
      </div>
      <div>
        <UpcommingsBooking />
      </div>
    </div>
  );
};

export default DashboardTable;
